function initRelativesState(item) {
	// assign state to all its children if checkbox is a parent
	if (item.classList.contains('c-accordion__header-checkbox')) {
		handleChildren(item);
	}
	// assign state to all parents
	handleParents(item);
}

function assignParentCheckboxState(item) {
	const siblings = Array.from(getChildren(item));
	const parentItem = getParent(item);

	if (item === parentItem) {
		return;
	}

	const checkStatus = siblings.map(item => item.checked);
	const every = checkStatus.every(Boolean);
	const some = checkStatus.some(Boolean);

	parentItem.checked = every;
	parentItem.indeterminate = !every && every !== some;
}

function getParent(element) {
	const parentId = element.getAttribute('data-parent');
	// eslint-disable-next-line unicorn/prefer-query-selector
	return document.getElementById(parentId);
}

function getChildren(element, parentId = element.getAttribute('data-parent')) {
	const childrenWrapper = document.querySelector(`#accordion-content-${parentId}`);

	return childrenWrapper.querySelectorAll('.c-checkbox');
}

function handleChildren(item) {
	const children = getChildren(item, item.id);

	for (const child of Array.from(children)) {
		child.checked = item.checked;
		child.indeterminate = false;
	}
}

function handleParents(item) {
	while (item) {
		const parentItem = getParent(item);

		assignParentCheckboxState(item);
		item = (item === parentItem) ? 0 : parentItem;
	}
}

function init() {
	const container = document.querySelector('#book-collections');

	if (container !== null) {
		for (let item of Array.from(container.querySelectorAll('.c-checkbox'))) {
			handleParents(item);

			item.addEventListener('change', event => {
				item = event.target;

				initRelativesState(item);
			});
		}
	}
}

export default {init};
